// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2gIlT","icon":"SortAdornment_icon__3_rPs","up":"SortAdornment_up__11d4C","down":"SortAdornment_down__yL3qI","active":"SortAdornment_active__kZsHw"};